/*
--- HEALTHPAK
--- Global Effects
--- By James Barnsley of PlasticStudio
*/

	
/* ===================================================================== SOCIAL FEEDS ======================= */
/* ========================================================================================================= */

function GetSocialFeed(){
    
    $('.load-social-feed').each( function(key,value){
        
        var container = $(value);
        
		$.ajax(	{
			url: $(this).attr('data-baseurl') +'/SocialFeedGetter',
			type: 'POST',
			data: {context: container.data('context')},
			success: function( response ){
				container.html( response );
			}
		});
        
    });
    
};



	
/* ===================================================================== GLOBAL FUNCTIONALITY ============== */
/* ========================================================================================================= */



/* ================================================== PRIMARY MENU HOVER PANEL ==== */

function SetupPrimaryHoverMenu(){

	$('#menu-primary .menu-item-wrapper.has-hover-menu').on('click', function(evt){

		$('.hover-menu').toggleClass('open');
	});
	
}
	
	
	
	
	
	
	
/* ================================================== FULL PAGE POPUP ==== */
	
function CloseFullPagePopup(){
	// fade em out
	$('#full-page-popup .background').delay(200).animate({'opacity':0},200, function(){ $('#full-page-popup').addClass('hide'); });
	$('#full-page-popup .inner').animate({'opacity':0},200);
}

function FullPagePopup( type, target, content ){
	
	// in case content hasn't been parsed
	content = (typeof content === "undefined") ? '' : content;
	
	// remove hide class
	$('#full-page-popup').removeClass('hide');
	
	// change content if we're injecting an iframe
	if( type == 'iframe' ){
		content = '<iframe src="'+$(target).attr('href')+'"></iframe>';
	}
	
	// inject content
	$('#full-page-popup .content').html(content);
	
	// if we've specified popup size (through trigger popupWidth and popupHeight attributes)
	if( typeof $(target).attr('popupWidth') !== 'undefined' ){
	
		// set size of content
		$('#full-page-popup .content').css({
				width: $(target).attr('popupWidth') + 'px',
				height: $(target).attr('popupHeight') + 'px'
			});
			
		// set horizontal position of popup
		$('#full-page-popup .inner').css({
				marginLeft: '-' + ($(target).attr('popupWidth') / 2) + 'px',
				width: $(target).attr('popupWidth')+ 'px'
			});
			
		// set vertical position of popup
		$('#full-page-popup .inner').css({
				marginTop: '-' + ($(target).attr('popupHeight') / 2) + 'px',
				height: $(target).attr('popupHeight') + 'px',
				top: '50%'
			});
	}
	
	
	// fade em in
	$('#full-page-popup .background').animate({'opacity':1},200);
	$('#full-page-popup .inner').delay(200).animate({'opacity':1},200);
	
	// create listener for close
	$('#full-page-popup .close-popup, #full-page-popup .background').on('click', function(){
		CloseFullPagePopup();
	});
	
}


/* --- LISTEN FOR IN-PAGE LINKS --- */

$('a.popup-trigger').on('click', function(evt){
	
	evt.preventDefault();
	
	FullPagePopup('iframe',$(this));
	
})


	
/* ================================================== HEADER SEARCH ==== */

function SubmitHeaderSearch(query){
	
	// submit form
	$('#menu-primary .search-wrapper form#SearchForm_SearchForm').submit();
}

function SetupHeaderSearch(){
	
	var wrapper = $('#menu-primary .menu-item.search-wrapper');
	var label = $('#menu-primary .menu-item.search-wrapper .search .label');
	var button = $('#menu-primary .menu-item.search-wrapper .search .submit-button');
	var field = $('#menu-primary .menu-item.search-wrapper .search input[type=text]');
			
	// bind <esc> to the collapse
	$(document).keypress(function (evt) {
		if (evt.keyCode == 27) {
			$(wrapper).removeClass('expanded').addClass('collapsed').css('width','45px');
		}
	});
	
	// listen for click on wrapper
	$(wrapper).on('click', function(evt){
		
		// expand
		if( $(wrapper).hasClass('collapsed') ){
			
			// expand the form
			$(this).addClass('expanded').removeClass('collapsed').css('width','200px');
			
			// focus on the input field
			$(field).focus();
			
			// bind <enter> to the submission of this query
			$(field).keypress(function (evt) {
				if (evt.which == 13) {
					
					// trigger submission
					SubmitHeaderSearch();
				}
			});
			
		// collapse? check first
		}else{
			if( $(evt.target).hasClass('submit-button') ){
				$(this).closest('.menu-item').find('form').submit();
			}
		}
		
	});
	
}

	
	
	
	
	
	
	
/* ============================================================================== PAGE BANNER ============== */
/* ========================================================================================================= */
	


	
/* ================================================== BANNER IMAGE ==== */

function PositionBannerImage(){
	
	// collect real image width from attributes
	var imageWidth = $('#page-banner .image img').attr('realwidth');
	var imageHeight = $('#page-banner .image img').attr('realheight');
	var containerWidth = $('#page-banner .inner').outerWidth();
	var leftPosition = -( imageWidth - containerWidth ) / 2;
	
	// set left position
	$('#page-banner .image img').css({
			'left': leftPosition +'px'
		});
}





	
/* ================================================================================== SLIDERS ============== */
/* ========================================================================================================= */

	
	
/* ======================================= UNIVERSAL SLIDE FUNCITONALITY === */

function Slide( direction, target ){
	
	// gather the facts
	var slideAmount = $(target).find('.slide').outerWidth();
	var originPosition = parseFloat( $(target).find('.liner').css('left').replace('px', '') );
	var destinationPosition = 0;
	var slideLinerWidth = parseFloat( $(target).find('.liner').outerWidth() );
	
	// we're sliding next
	if( direction == 'next' ){
	
		// check limits
		if( originPosition <= -(slideLinerWidth - slideAmount) ){
			
			// slide to first slide
			destinationPosition = 0;
		}else{		
		
			// calculate next slide destination
			destinationPosition = originPosition - slideAmount;
		}
		
	// we're sliding previous
	}else if( direction == 'prev' ){
	
		// check limits
		if( originPosition >= 0 ){
			
			// slide to last slide
			destinationPosition = -( slideLinerWidth - slideAmount );
			
		}else{
		
			// calculate prev slide destination
			destinationPosition = originPosition + slideAmount;
		}
		
	}
	
	// animate to destination position
	$(target).find('.liner').animate({
				'left': destinationPosition
			}, 200
		);	
}


	
/* ======================================= SLIDING PRODUCT GRID === */

function SetupSlidingProductGrid(){ 

	// grab calculate width of liner
	var linerWidth = $('.product-grid.slider-grid .slide').outerWidth() * $('.product-grid.slider-grid .slide').length;
	
	// calculate width of each slide
	var slideWidth = $('.product-grid.slider-grid .grid-items').outerWidth();
	
	// set new width of liner
	$('.product-grid.slider-grid .grid-items .liner').css({
		'width': linerWidth +'px'
	});
		
	// set width of slides
	$('.product-grid.slider-grid .slide').css({
		'width': slideWidth +'px'
	});
		
	// setup listener for navigation clicks
	$('.product-grid.slider-grid .slide-controller').on('click', function(){
		
		// trigger slide function
		Slide( 
				$(this).attr('direction'), 							// direction (ie next, prev)
				$('.product-grid.slider-grid .grid-items')			// target (ie slide wrapper)
			);
	});
}



	
/* ======================================= SLIDING PRODUCT COMMENTS === */

function SetupSlidingProductComments(){
	
	// grab calculate width of liner
	var linerWidth = $('.product-comments .comment').outerWidth() * $('.product-comments .comment').length;
	var slideWidth = $('.product-comments').outerWidth();
	
	// set new width of liner
	$('.product-comments .liner').css({
		'width': linerWidth +'px'
	});
		
	// set width of comments
	$('.product-comments .comment').css({
			'width': slideWidth +'px'
		});
		
	// setup listener for navigation clicks
	$('.product-comments .slide-controller').on('click', function(){
	
		// trigger slide function
		Slide( 
				$(this).attr('direction'), 				// direction (ie next, prev)
				$('.product-comments .slider')	// target (ie slide wrapper)
			);
	});
}



	
/* ======================================= PRODUCT THUMBNAILS GALLERY === */

function SetupProductPhotoPopups(){

	// setup objects
	var fullPhoto = $('.product-gallery .large.photo img');
	
	// click the current big pic
	$(fullPhoto).on('click', function(){
		
		// parse content to pop-upper
		FullPagePopup( 'content', $(fullPhoto), '<img src="'+$(fullPhoto).attr('highres')+'" class="product-photo" />' );
		
	});

}

function SetupProductThumbnails(){ 
	
	// setup objects
	var fullPhoto = $('.product-gallery .large.photo img');
	var thumbnails = $('.product-gallery .thumbnails .thumbnail img');
	
	// click a thumbnail
	$(thumbnails).on('click', function(){
		
		// save target big-pic URL
		var targetURL = $(this).attr('rel');
		var highresURL = $(this).attr('highres');
		
		// fade out big pic
		$(fullPhoto).animate({
					opacity: 0
				},200,function(){
					
					// swap out big pic src
					$(fullPhoto).attr({
							'src': targetURL,
							'highres': highresURL
						});
					
					// fade in big pic
					$(fullPhoto).animate({
								opacity: 1
							},200
						);
					
				}
			);
		
	});
}



	
/* ======================================= PRODUCT RANGE EXPLORER PANEL === */


/* --- SETUP --- */

function SetupProductRangeExplorer(){ 
	
	// key elements
	var container = $('#range-explorer-panel');
	var trigger = $('#range-explorer-panel-trigger');
	var body = $('#main');
	var background = $('#main .fade-to-white');
	
	// on click of the trigger
	$(trigger).on('click', function(){
		
		// expand
		if( $(trigger).hasClass('collapsed') ){
			ProductRangeExplorerExpander(container,trigger,body,background);	
			
		// collapse
		}else{
			ProductRangeExplorerCollapser(container,trigger,body,background);
		}		
	});
	
	// on click of the fade-to-white background
	$(background).on('click', function(){
	
		// collapse the expanded panel
		ProductRangeExplorerCollapser(container,trigger,body,background);
	});
	
	// initiate slider
	SetupProductRangeExplorerSlider();	
}


/* --- EXPAND --- */

function ProductRangeExplorerExpander(container,trigger,body,background){
			
	$(trigger).removeClass('collapsed').addClass('expanded');
	$(container).removeClass('hide');
	$(container).animate({
				height: '247px'
			},200
		);
	$(background).removeClass('hide');
	$(background).animate({
				opacity: 1
			},200
		);

}



/* --- COLLAPSE --- */

function ProductRangeExplorerCollapser(container,trigger,body,background){

	$(trigger).removeClass('expanded').addClass('collapsed');
	$(container).animate({
				height: '0px'
			},200,function(){
				$(container).addClass('hide');
			}
		);
	$(background).animate({
				opacity: '0'
			},200,function(){
				$(background).addClass('hide');
			}
		);
		
}


/* --- RANGE SLIDER --- */

function SetupProductRangeExplorerSlider(){ 
	
	// grab calculate width of liner
	var linerWidth = $('#range-explorer-panel .range-grid .grid-item').outerWidth() * $('#range-explorer-panel .range-grid .grid-item').length;
	
	// calculate width of each slide
	var slideWidth = $('#range-explorer-panel .inner').outerWidth();
	
	// set new width of liner
	$('#range-explorer-panel .range-grid .liner').css({
			'width': linerWidth +'px'
		});
		
	// set width of slides
	$('#range-explorer-panel .range-grid .slide').css({
			'width': slideWidth +'px'
		});
		
	// setup listener for navigation clicks
	$('#range-explorer-panel .slide-controller').on('click', function(){
		
		// trigger slide function
		Slide( 
				$(this).attr('direction'), 							// direction (ie next, prev)
				$('#range-explorer-panel .range-grid')			// target (ie slide wrapper)
			);
	});
}






	
/* ==================================================================================== FORMS ============== */
/* ========================================================================================================= */

	





	
/* ======================================================================= CONTRACT PACKAGING ============== */
/* ========================================================================================================= */


function SetupContractPackaging(){	
	
	/* RADIO BUTTON */
	
	$('#contract-packaging-filter .faux-radio .radio.label').on('click', function(evt){
	
		$('#contract-packaging-filter .faux-radio .radio.label').removeClass('active');		
		$(this).siblings('input[type=hidden]').val( $(this).attr('data-value') );
		$(this).addClass('active');
	});
	
	
	$('#contract-packaging-filter .chat-with-us.button').on('click', function(evt){
		
		var email_body = '';
		
		// compile attributes selected
		$('#contract-packaging-filter .contract-input').each( function(evt){
			
			if( $(this).hasClass('use-html') ){
			
				email_body += $(this).attr('data-label') + '\n' + $(this).html() + '\n\n';
				
			}else if( $(this).is(':radio') ){
			
				if( $(this).attr('checked') == 'checked' )			
					email_body += $(this).attr('data-label') + '\n' + $(this).val() + '\n\n';
				
			}else{
			
				email_body += $(this).attr('data-label') + '\n' + $(this).val() + '\n\n';
				
			}
			
		});
		
		email_body += 'ADD ANY EXTRA DETAILS BELOW \n\n\n\n';
		
		window.location = 'mailto:toby@healthpak.co.nz?subject=Contract+Packaging+Query&body='+encodeURIComponent(email_body);
	
	});
	
	
	
	// ------------------------------- OLD :::
	
	// if we have a filter currently
	if( $('#contract-packaging-filter').attr('data-current-filter') ){
		
		// get the current values
		var currentFilterURL = $('#contract-packaging-filter').attr('data-current-filter');
		var currentFilterName = $('#contract-packaging-filter').find('.dropdown-list .item.'+$('#contract-packaging-filter').attr('data-current-filter')).html();
		
		// remove placeholder label and inject dropdown value
		$('#contract-packaging-filter').find('.label').removeClass('placeholder').html( currentFilterName ).attr('data-value',currentFilterURL);
		
		// scroll down to where we were
		$('html, body').animate({
			scrollTop: $("#contract-packaging-filter").offset().top
		}, 600);
		
		// apply the value to the (hidden) contact form
		$('#contract-packaging-form #ProductType select').val(currentFilterName);
	}
	
	// listen for clicks anywhere on the document
	$(document).on('click', function(evt){
		
		// save dropdown object
		var dropdown = $('.dropdown-field.expanded');
		
		// check if target is, or is a child of, the dropdown
		if (!dropdown.is(evt.target) && dropdown.has(evt.target).length === 0){
			$('.dropdown-field').removeClass('expanded');
		}
		
	});
	
	
	/* === CLICK OF FIELD OBJECT === */
	
	$('#contract-packaging-filter .dropdown-field').on('click', function(evt){
		
		// already expanded
		if( $(this).hasClass('expanded') ){
			
			// check if we have clicked on a dropdown item
			if( $(evt.target).hasClass('item') ){
				
				// remove placeholder label and inject dropdown value
				$(this).find('.label').removeClass('placeholder').html( $(evt.target).html() ).attr('data-value',$(evt.target).attr('data-value'));
			}
		
			// collapse
			$(this).removeClass('expanded');
			
		// currently collapsed
		}else{
		
			// expand
			$(this).addClass('expanded');
			
		}
		
	});
	
	
	
	/* === CLICK OF APPLY BUTTON === */
	
	$('#contract-packaging-filter .apply.button').on('click', function(evt){
		
		// compile attributes selected
		var productType = $('#contract-packaging-filter .dropdown-field .label').attr('data-value');
		
		// redirect to page
		window.location = $('#contract-packaging-filter').attr('data-url').replace(/\/?$/, "/") + 'filter/' + productType;
	
	});
	
}




	
/* ======================================================================= RESPONSIVE LAYOUTS ============== */
/* ========================================================================================================= */

function MobileNav(){
    $('.hamburglar').click( function(){
    	$(this).toggleClass('open');
        $('.menu').toggleClass('open');
    });
}



// When window resizes check width and if mobile device, check inner width
function RefreshPage() {
	
	// Retest product customer comments slide widths
	SetupSlidingProductComments();
}

function ProductTagClickable() {
	
	$('.product-tags .tag-item img').click( function() {
		$('.product-tags .tag-item .popup').removeClass('visible');		
		$(this).siblings('.popup').toggleClass('visible');		
	});

}








/* ============================================================================ HOMEPAGE SLIDESHOW ========= */
/* ========================================================================================================= */

function SetupHomepageSlider(){

    // Slick settings (just a couple)
    // Full list of settings can be found here: https://github.com/kenwheeler/slick/#settings
    var cfg = {

        dots: true,
        speed: 300,
        autoplay: true,
        autoPlayspeed: 1000,
        cssEase: 'ease',
        draggable: true,
        arrows: true,
        infinite: true,
        dots: true,
		arrows: false,
		lazyLoad: 'ondemand',

    };

    // Initialize
    $( '.kbslideshow' ).slick( cfg );
};





/* ============================================================================ DOCUMENT LOAD ============== */
/* ========================================================================================================= */


$( document ).ready( function(){

	MobileNav();
	
	// Listen for window resize
	$(window).resize(function() {
		RefreshPage();
	});

	// social feed(s)
	if( $('.load-social-feed').length > 0 )
		GetSocialFeed();
	
	// setup hover menu
	if( $('#menu-primary .hover-menu').length > 0 )
		SetupPrimaryHoverMenu();

	// setup header search button/form
	if( $('#menu-primary .menu-item.search-wrapper').length > 0 )
		SetupHeaderSearch();

	// setup page banner image positioning
	if( $('#page-banner img').length > 0 )
		PositionBannerImage();

	// setup product slide grid
	if( $('.product-grid.slider-grid').length > 0 )
		SetupSlidingProductGrid();

	// setup product slide grid
	if( $('.product-comments').length > 0 )
		SetupSlidingProductComments();

	// setup product photo popups
	if( $('.product-gallery').length > 0 )
		SetupProductPhotoPopups();

	// setup product photo thumbnails
	if( $('.product-gallery .thumbnails').length > 0 )
		SetupProductThumbnails();

	// setup product range explorer
	if( $('#range-explorer-panel').length > 0 )
		SetupProductRangeExplorer();

	// setup contract packaging filter
	if( $('#contract-packaging-filter').length > 0 )
		SetupContractPackaging();

	// homepage slider
	if( $('.kbslideshow').length > 0 )
		SetupHomepageSlider();
		
	if( $('.product-tags .tag-item .popup').length > 0 ) {
		if( $(window).width() < 1000 ) {
			ProductTagClickable();
		}
	}
    
    /* ======================================= PRODUCT ENQUIRY === */
    $('.product-buttons .enquire').on('click',function(evt){
        evt.preventDefault();
        FullPagePopup( 'iframe', $(evt.target) );
    });
	
});
